import React, { useEffect, useState } from "react";
import "./weather.scss";
import axios from "axios";
import TextField from "@mui/material/TextField";

const Weather = () => {
  const [search, setSearch] = useState("surat");

  const [city, setCity] = useState("");

  const fetchData = async () => {
    const url = "https://api.openweathermap.org/data/2.5/weather";
    const APIkey = "04b8c3c30e83f6ae5a3f7895bcab1537";

    await axios
      .get(url, {
        params: {
          q: `${search}`,
          appid: `${APIkey}`,
        },
      })
      .then((res) => {
        setCity(res.data);
      });
  };
  useEffect(() => {
    fetchData();
  }, [setSearch]);

  return (
    <>
      <div
        className="container"
        style={{ marginLeft: "480px", marginTop: "20px", width: "500px" }}
      >
        <TextField
          id="outlined-basic"
          label="Search City"
          variant="outlined"
          sx={{ margin: "auto", width: "550px" }}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <article className="widget">
        <div className="weatherIcon">
          <i className="wi wi-day-cloudy"></i>
        </div>
        {!city ? (
          <>
            <p>No data Found</p>
          </>
        ) : (
          <>
            <div className="weatherInfo">
              <div className="temperature">
                <span>{city.main.temp}&deg;</span>
              </div>
              <div className="description">
                <div className="weatherCondition">CLOUDY</div>
                <div className="place">{city.name}</div>
              </div>
            </div>
            <div className="date">{city.wind.speed}</div>
          </>
        )}
      </article>
    </>
  );
};

export default Weather;
